import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f635b9be&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=f635b9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f635b9be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f635b9be')) {
      api.createRecord('f635b9be', component.options)
    } else {
      api.reload('f635b9be', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f635b9be&scoped=true&", function () {
      api.rerender('f635b9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/vsm-management/Index.vue"
export default component.exports